import { API_ENDPOINT } from "../core/services/http.service"

export interface MicaStats {
  scope: string
  totalEntities: number
  cost: { items: Array<{ key: string; label: string; min: number; max: number }> }
  geography: { euBased: number; nonEu: number; unknown: number }
  origin: { cryptoNative: number; incumbent: number; unknown: number }
  sectors: Array<{ name: string; count: number }>
  topCountries: Array<{ name: string; count: number }>
  generatedAt: string
}

/**
 * Fetches the public MiCA stats endpoint (tbw-backend GET /mica/stats).
 * Results are memoised per licence-type scope for the page lifetime so several
 * <tbw-mica-charts> elements on the same page share a single request.
 */
export class MicaStatsService {
  private cache = new Map<string, Promise<MicaStats>>()

  get(type: string = "casp"): Promise<MicaStats> {
    const scope = type.trim().toLowerCase() || "casp"
    let pending = this.cache.get(scope)
    if (!pending) {
      pending = this.fetch(scope).catch((err) => {
        this.cache.delete(scope) // allow a retry on next mount after a failure
        throw err
      })
      this.cache.set(scope, pending)
    }
    return pending
  }

  private async fetch(scope: string): Promise<MicaStats> {
    const base = String(API_ENDPOINT).replace(/\/+$/, "")
    const res = await fetch(`${base}/mica/stats?type=${encodeURIComponent(scope)}`, {
      headers: { Accept: "application/json" },
    })
    if (!res.ok) throw new Error(`mica/stats ${res.status}`)
    return (await res.json()) as MicaStats
  }
}

export const micaStatsService = new MicaStatsService()
